import { useField } from "formik";
import { FC } from "react";

import { FormControl } from "~/src/components/common/forms/FormControl";
import { FormikTextField } from "~/src/components/common/forms/FormikTextField";

export type UrlRegexFieldProps = {
  urlMatchTypeFieldName: string;
  regexFieldName: string;
};

export const UrlRegexField: FC<UrlRegexFieldProps> = ({
  urlMatchTypeFieldName,
  regexFieldName,
}) => {
  const [matchTypeField] = useField(urlMatchTypeFieldName);

  const urlMatchType = matchTypeField.value as string | undefined;

  if (urlMatchType !== "REGEX_MATCH_TYPE") {
    return null;
  }

  return (
    <FormControl
      label="正規表現"
      help="ホスト名とパス（末尾のスラッシュ除く）に一致します。プロトコル（http://、https://）やポート番号（:3000）は含まれません。例: example\.com/products/\d+"
    >
      <FormikTextField
        type="text"
        mode="fill"
        name={regexFieldName}
        placeholder="例: example\.com/products/\d+"
      />
    </FormControl>
  );
};
